import { organizationTypes } from 'common/constants';

// Organization type, not role: true only when logged in to the super admin organization itself.
export default function isSuperAdminOrganizationType(rootStore) {
	const abrv = rootStore.applicationStore.organizationType;
	return !!abrv && abrv.toUpperCase() === organizationTypes.superAdministrator.toUpperCase();
}
